import 'roboto-fontface/css/roboto/roboto-fontface.css'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import {AUTH_LOG_USER_IN_WITH_TOKEN, GET_KEY, INIT_STORE, SWITCH_APPLICATION_LANGUAGE} from "@/store/action-types"
import {AUTH_TOKEN, CURRENT_UI_LANGUAGE, SUPPORTED_LANGUAGES} from "@/store/getter-types"
import {isTokenExpiration} from "@/services/util"
import {PiniaVuePlugin, createPinia} from "pinia";
import Language from "@/model/Language";

Vue.config.productionTip = false as boolean

(async () => {
  try {
    await store.dispatch(INIT_STORE)

    const token = store.getters[AUTH_TOKEN]

    if (token) {

      let isTokenExpired: boolean = isTokenExpiration(token)

      if (!isTokenExpired) {
        await store.dispatch(AUTH_LOG_USER_IN_WITH_TOKEN, token)
        store.dispatch(GET_KEY)
      }
    }
  } finally {
    Vue.use(PiniaVuePlugin)

    new Vue({
      router,
      store,
      pinia: createPinia(),
      i18n,
      vuetify,
      render: h => h(App),
      created () {
        const supportedLanguages: Language[] = store.getters[SUPPORTED_LANGUAGES]
        const foundLanguage: Language | undefined = supportedLanguages.find((item: Language) => item.code === i18n.locale)
        store.dispatch(SWITCH_APPLICATION_LANGUAGE, foundLanguage ? foundLanguage : store.getters[CURRENT_UI_LANGUAGE])
      }

    }).$mount('#app')
  }
})()
